import dialog from './dialog';

const base = `${util.urlBase()}${
    window.location.pathname.includes('/past-employees')
        ? 'past-employees/'
        : ''
}`;
const events = {};
const isLocked = (value) => [10000, 10010].includes(value);
const logoutText = 'Please refresh the page to log in again.';
const logoutTitle = 'Your session has ended';
const Timeout = {};
let countdownTimer;
let pingTimer;
const unavailableTitle = 'Aurion Unavailable';

Timeout.startPinging = (interval = 30000) => {
    pingTimer = setInterval(Timeout.ping, interval);
    // Because the internal is hard coded to 30s, it's fine to use setInterval
    // If the interval is configurable, setTimeout should be used.
};

const closeDialog = (timeOutDialog) => {
    timeOutDialog.close();
    timeOutDialog.remove();
};

const getModalTitle = (timeOutDialog) => timeOutDialog.querySelector('.dialog-title').textContent;

Timeout.ping = () => {
    window.loader.ignore = true;
    ajax({
        method: 'GET',
        url: `${base}status/ping`,
        documentType: 'json',
        callback(response) {
            if (!response) return;

            const existingDialog = document.getElementById('time-out-dialog');
            if (isLocked(response.status.value)) {
                if (!existingDialog?.open || getModalTitle(existingDialog) !== unavailableTitle) {
                    const timeOutDialog = dialog.showDialog({
                        id: 'time-out',
                        title: unavailableTitle,
                        htmlBody: response.status.text,
                        customClasses: {
                            htmlBody: ['text-center', 'dialog-message'],
                        },
                        centerButtons: true,
                        centerHeader: true,
                        btnConfigs: [{
                            text: 'Retry',
                            colour: 'Primary',
                            onClickEvent: () => {
                                ajax({
                                    url: `${base}status/ping`,
                                    documentType: 'json',
                                }, (response) => {
                                    if (response && isLocked(response.status.value)) {
                                        dialog.setHtmlBody(timeOutDialog, response.status.text);
                                    } else {
                                        closeDialog(timeOutDialog);
                                    }
                                });
                            },
                        }],
                    });
                } else {
                    dialog.setHtmlBody(existingDialog, response.status.text);
                }
            } else {
                if (existingDialog?.open && getModalTitle(existingDialog) === unavailableTitle) {
                    // close alert if Aurion was locked but is now unlocked
                    closeDialog(existingDialog);
                }

                if (response.status.value === 10007) {
                    // session is about to time out
                    const alertTime = /(?:~\|~)([0-9]+)/.exec(response.status.text)[1];
                    clearInterval(pingTimer);
                    Timeout.showAlert(alertTime);
                } else if (sessionExpired(response.status.value)) {
                    clearInterval(pingTimer);
                    sessionStorage.removeItem('navActiveParent');
                    Timeout.showLogoutDialog(logoutTitle, logoutText);
                }
            }
        },
    });
};

Timeout.showAlert = (alertTime) => {
    const timeOutDialog = dialog.showDialog({
        id: 'time-out',
        title: 'Your session is about to expire...',
        htmlBody: `
            <p>
                Click the button below to stay signed in,<br>or your session will end in:
            </p>
            <p>
                <b data-timeout></b>
            </p>
        `,
        customClasses: {
            htmlBody: 'text-center',
        },
        centerButtons: true,
        centerHeader: true,
        btnConfigs: [{
            text: 'Continue',
            colour: 'Primary',
            onClickEvent: () => {
                new Promise((resolve, reject) => {
                    clearTimeout(countdownTimer);
                    window.loader.ignore = true;

                    ajax({
                        method: 'GET',
                        url: `${base}status/extend`,
                        documentType: 'json',
                        success() {
                            closeDialog(timeOutDialog);
                            resolve();
                        },
                        failure(res, xhr, notify) {
                            dialog.setHtmlBody(timeOutDialog, notify.text);
                            reject();
                        },
                    });
                }).then(() => {
                    Timeout.startPinging();
                    document.body.dispatchEvent(new Event('timeout.extended'));
                }).catch((text) => {
                    const title = 'Failed to extend the session';
                    Timeout.showLogoutDialog(title, text);
                });
            },
        }],
    });

    Timeout.countdown(alertTime, timeOutDialog);
    document.body.dispatchEvent(new Event('timeout.alert'));
};

Timeout.sendTimeOut = (timeOutDialog) => {
    timeOutDialog.querySelector('.btn-primary').disabled = true;
    window.loader.ignore = true;
    ajax({
        method: 'GET',
        url: `${base}status/timeOut`,
        documentType: 'json',
        callback() {
            // Show the logout dialog no matter what comes back from Backchannel
            closeDialog(timeOutDialog);
            Timeout.showLogoutDialog(logoutTitle, logoutText);
        },
    });
};

Timeout.showLogoutDialog = (title, text) => {
    dialog.showDialog({
        id: 'time-out',
        title,
        htmlBody: text,
        customClasses: {
            htmlBody: ['text-center', 'dialog-message'],
        },
        centerButtons: true,
        centerHeader: true,
        btnConfigs: [{
            text: 'Refresh',
            colour: 'Primary',
            closeDialog: false,
            onClickEvent: () => {
                // To prevent drifting in IE10 when reloading
                setTimeout(() => {
                    window.location.reload(true);
                }, 1);
            },
        }],
    });

    document.body.dispatchEvent(new Event('timeout.logout'));
};

Timeout.countdown = (alertTime, timeOutDialog) => {
    if (0 < alertTime) {
        const minutes = Math.floor(alertTime / 60);
        const seconds = alertTime % 60;

        timeOutDialog.querySelector('b[data-timeout]').textContent = (
            `${timeBeautifier(minutes)} : ${timeBeautifier(seconds)}`
        );

        countdownTimer = setTimeout(() => {
            Timeout.countdown(alertTime - 1, timeOutDialog);
        }, 1000);
    } else {
        clearTimeout(countdownTimer);
        Timeout.sendTimeOut(timeOutDialog);
    }
};

Timeout.on = (evt, listener) => {
    if (!events[evt]) events[evt] = [];

    events[evt].push(listener);
    document.body.addEventListener(evt, listener);
};

Timeout.removeAllListeners = () => {
    Object.keys(events).forEach((evt) => {
        events[evt].forEach((listener) => {
            document.body.removeEventListener(evt, listener);
        });
        events[evt] = [];
    });
};

function timeBeautifier(time) {
    return time > 9
        ? time
        : `0${time}`;
}

function sessionExpired(code) {
    // 10005: Logout successfully
    // 10002: User logon required
    // -10003: The system could not log you on
    const statusCode = [
        10005,
        10002,
        -10003,
    ];
    return statusCode.includes(code);
}

document.addEventListener('DOMContentLoaded', () => {
    Timeout.startPinging();
});

export default Timeout;
